import { classNames } from "@greeter/util";
import React, { useEffect, useState } from "react";
import { useSpring, animated, config } from "@react-spring/web";
import { useDrag } from "@use-gesture/react";
import { useMeasure } from "@greeter-venue/utility/Hooks";
import { SlideBox } from "../SlideBox";
import css from "./UnconfirmedStage.module.scss";

export type UnconfirmedStageProps = {
  onAccept: () => void;
  text?: string;
  className?: string;
};

export const UnconfirmedStage: React.FC<UnconfirmedStageProps> = ({
  onAccept,
  text = "Godkend",
  className,
}) => {
  const [slideBoxBind, slideBoxDimensions] = useMeasure<HTMLDivElement>(true);
  const [buttonBind, buttonDimensions] = useMeasure<HTMLButtonElement>();

  const [{ xy }, set] = useSpring(() => ({ xy: [0, 0], config: config.stiff }));

  const [fullSwipe, setFullSwipe] = useState<boolean>(false);

  const bind = useDrag(({ event, down, movement: [mx] }) => {
    event.preventDefault();
    const slideBoxWidth =
      slideBoxDimensions.width > 0 ? slideBoxDimensions.width : 500;
    const buttonWidth =
      buttonDimensions.width > 0 ? buttonDimensions.width : 100;

    const slideBoxWidthMinusButtonWidth = slideBoxWidth - buttonWidth;
    const pointOfNoReturn = slideBoxWidthMinusButtonWidth;
    if (down && mx > 0 && mx < pointOfNoReturn && !fullSwipe)
      set({ xy: [mx, 0] });
    else if (mx >= pointOfNoReturn) {
      set({ xy: [slideBoxWidthMinusButtonWidth, 0] });
      setFullSwipe(true);
    } else if (!fullSwipe) {
      set({ xy: [0, 0] });
    }
  });
  useEffect(() => {
    if (fullSwipe) {
      onAccept();
      const id = setTimeout(() => {
        setFullSwipe(false);
        set({ xy: [0, 0] });
      }, 3000);

      return () => clearTimeout(id);
    }
  }, [fullSwipe]);

  return (
    <SlideBox {...slideBoxBind} id="slideBox">
      <animated.button
        {...classNames(css.btnSmall, className)}
        {...buttonBind}
        {...bind()}
        style={{
          // @ts-ignore
          transform: xy.to((x, y) => `translate3d(${x}px, ${0}px, 0)`),
        }}
      >
        {text}
      </animated.button>
    </SlideBox>
  );
};
